<template>
  <div class="training-class" @click="$emit('on-open','video')">
    <img :src="value.avatar || (value.project && value.project.avatar) || 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/misc/px.jpg'"   />
    <div class="flex-wrap flex-between" style="width:100%">
      <div>
      <div class="tc-title" v-if="value.project">{{ value.project.name }}</div>
      <div class="tc-project">{{value.name}}</div>
      <div class="tc-date">{{value.created_at}}</div>
    </div>
     <div  style="flex-shrink:0;" class="flex-col align-end"  >
        <BaseNameBoard :uid="value.project && value.project.charger || value.charger"  />
       
     </div>
    </div>

    <div class="flex-wrap share-btn" style="position:absolute;right:15px;top:15px;color:var(--primary);cursor:pointer;border:1px solid var(--border);border-radius:3px;padding:0 3px;" @click.stop="share">
        <BaseIcon icon="share" size="25" style="margin-right:2px;" />
      
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: {
    value: {
      type: Object,
      default: ()=>({}),
    },
  },
  methods:{
    share(e){
      e.stopPropagation();
     
    // 将视频地址复制到剪切板 video_url
    if (this.value && this.value.video_url) {
      let baseUrl = location.origin; // 获取当前域名地址和协议
      let video_url = baseUrl + '/tools/video?id=' + this.value.id;
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(video_url)
          .then(() => {
            this.Success('已复制视频地址!');
          })
          .catch(() => {
            this.Error('复制失败，请手动复制');
          });
      } else {
        // 兼容部分旧浏览器
        const input = document.createElement('input');
        input.value = video_url;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand('copy');
          this.Success('已复制视频地址!');
        } catch (e) {
          this.Error('复制失败，请手动复制');
        }
        document.body.removeChild(input);
      }
    } else {
      this.Error('此视频未上传文件，复制失败');
    }
    }
  }
};
</script>

<style lang="less">
.training-class{
  display:flex;
  position:relative;
  flex-direction: column;
  width:calc(20% - 10px);
  max-width:300px;
  align-items: flex-start;
  background:var(--bg2);
  margin:5px;
  padding:10px;
  transition: all 0.3s;
  cursor: pointer;
  border-radius: 10px;

  background:var(--bg2);
  border:1px solid var(--border);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  img{
    width:100%;
    height:140px;
    margin-bottom:10px;
  }
  .tc-title{
    font-size:16px;
    font-weight: bold;
    color:var(--primary);
  }

  .tc-date{
    font-size:12px;
  }

}

.training-class:hover{
  color:var(--primary);
  img{

  filter:none;
  }
}

.training-class:active{
  position: relative;
  right:-1px;
  bottom:-1px;
}

.share-btn:hover{
  filter:brightness(1.2);
}
</style>
